import { createTheme } from "@fluentui/react";

const UnicliTheme = createTheme({
  palette: {
    themePrimary: "#357c7c",
    themeLighterAlt: "#f4fafa",
    themeLighter: "#d5eaea",
    themeLight: "#b3d8d8",
    themeTertiary: "#74b1b1",
    themeSecondary: "#468d8d",
    themeDarkAlt: "#307070",
    themeDark: "#295f5f",
    themeDarker: "#1e4646",
    neutralLighterAlt: "#faf9f8",
    neutralLighter: "#f3f2f1",
    neutralLight: "#edebe9",
    neutralQuaternaryAlt: "#e1dfdd",
    neutralQuaternary: "#d0d0d0",
    neutralTertiaryAlt: "#c8c6c4",
    neutralTertiary: "#c9c9c9",
    neutralSecondary: "#949494",
    neutralPrimaryAlt: "#626262",
    neutralPrimary: "#4d4d4d",
    neutralDark: "#3a3a3a",
    black: "#2b2b2b",
    white: "#ffffff",
    hyperlink: "#0F6CBD",
    errorRed: "#FF0000",
  },
});

export default UnicliTheme;
